/* istanbul ignore file */
export * from './ExpressServiceInfo';
